import { render } from "./OnlineAllCanvas2.vue?vue&type=template&id=45c91158"
import script from "./OnlineAllCanvas2.vue?vue&type=script&lang=js"
export * from "./OnlineAllCanvas2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__